import React from 'react';

import { createStyles } from '@mantine/core';

import MainContent from './MainContent'
import SystemAlert from './SystemAlert'
import Navbar from './Navbar'
import ProfileModal from '../users/ProfileModal'
import Direct from "../users/Direct";
import ContentReadonlyModal from "../spaces_neo/presentations/content/ContentReadonlyModal";
import FilterMembersModal from "../spaces_neo/sidebar/FilterMembersModal";

const useStyles = createStyles((theme, { registrationView }) => ({
  appBody: {
    display: "flex",
    flexFlow: "row"
  },
  appMainFrame: {
    width: "100vw",
    height: `calc(100vh - ${registrationView ? 0 : theme.other.headerHeight}px)`,
    flex: 1,
    boxSizing: "border-box",
  }
}))

export default function Body() {
  const registrationView = (window.location.pathname.indexOf("/registration/view") >= 0 || window.location.pathname.indexOf("/register") >= 0) ? true : false;
  const { classes } = useStyles({registrationView});

  return (
    <div className={classes.appBody}>
      <Navbar />
      <div className={classes.appMainFrame}>
        <MainContent />
        <SystemAlert />
        <ContentReadonlyModal />
        <ProfileModal />
        <Direct />

        <FilterMembersModal />

      </div>
    </div>
  );
}
